import React from 'react';
import { Badge } from 'reactstrap';

const severityConfig = {
    debug: { color: 'secondary', icon: 'fa-bug', label: 'Debug' },
    info: { color: 'info', icon: 'fa-info-circle', label: 'Info' },
    warning: { color: 'warning', icon: 'fa-exclamation-triangle', label: 'Warning' },
    critical: { color: 'danger', icon: 'fa-exclamation-circle', label: 'Critical' }
};

const SeverityBadge = ({ severity, showLabel = true, small = false }) => {
    const config = severityConfig[severity] || severityConfig.info;
    const textClass = config.color === 'warning' ? 'text-dark' : '';

    return (
        <Badge
            color={config.color}
            className={`${textClass} ${small ? 'px-1 py-0' : ''}`}
            style={{ borderRadius: 0 }}
        >
            <span className={`fas ${config.icon} ${showLabel ? 'me-1' : ''}`} />
            {showLabel && config.label}
        </Badge>
    );
};

export default SeverityBadge;
